const CONFIG = {
  ENV: '',
  GERMANY_DIVISION_LOCATION_ID: 0,
  GLITCHTIP_DSN:
    import.meta.env.VITE_GLITCHTIP_DSN ??
    'https://a4197b6da4d44a3890524f9f6c4814b4@glitchtip.dev.knowme.biz/1',
  HOST:
    import.meta.env.VITE_ENVIRONMENT === 'local'
      ? import.meta.env.VITE_HOST_URL_LOCAL
      : import.meta.env.VITE_HOST_URL,
  MAINTENANCE: false,
  OKTA_REDIRECT_URL: '',
  SWEDEN_DIVISION_LOCATION_ID: 0,
};

export const CONFIG_ENV = {
  DEV: 'dev',
  PROD: 'prod',
} as const;

export const DEFAULT_LANGUAGE = 'en';
export const PROFILE_SEARCH_PAGE_SIZE = 32;
export default CONFIG;
